"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "camposanto": {
    "cebe28b8": [{
      "hkey": "54d81a47",
      "slug": "ca-bianca",
      "name": "Ca' Bianca",
      "primary": true,
      "skipSearch": false
    }],
    "cabianca": [{
      "hkey": "54d81a47",
      "slug": "ca-bianca",
      "name": "Ca' Bianca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "368d5a11": [{
      "hkey": "0d7d5d18",
      "slug": "camposanto",
      "name": "Camposanto",
      "primary": true,
      "skipSearch": false
    }],
    "cadecoppi": [{
      "hkey": "0d7d5d18",
      "slug": "camposanto",
      "name": "Camposanto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f850f362": [{
      "hkey": "0d7d5d18",
      "slug": "camposanto",
      "name": "Camposanto",
      "primary": true,
      "skipSearch": false
    }],
    "ghirone": [{
      "hkey": "0d7d5d18",
      "slug": "camposanto",
      "name": "Camposanto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "24997f85": [{
      "hkey": "1a8cd12b",
      "slug": "capoluogo",
      "name": "Capoluogo",
      "primary": true,
      "skipSearch": false
    }],
    "localita-capoluogo": [{
      "hkey": "1a8cd12b",
      "slug": "capoluogo",
      "name": "Capoluogo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "3b088b51": [{
      "hkey": "0d7d5d18",
      "slug": "camposanto",
      "name": "Camposanto",
      "primary": true,
      "skipSearch": false
    }],
    "passo": [{
      "hkey": "0d7d5d18",
      "slug": "camposanto",
      "name": "Camposanto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8ab0f42e": [{
      "hkey": "0d7d5d18",
      "slug": "camposanto",
      "name": "Camposanto",
      "primary": true,
      "skipSearch": false
    }],
    "passovecchio": [{
      "hkey": "0d7d5d18",
      "slug": "camposanto",
      "name": "Camposanto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cf20e9ce": [{
      "hkey": "0d7d5d18",
      "slug": "camposanto",
      "name": "Camposanto",
      "primary": true,
      "skipSearch": false
    }],
    "sant-anna": [{
      "hkey": "0d7d5d18",
      "slug": "camposanto",
      "name": "Camposanto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;